import { render, staticRenderFns } from "./section-image.vue?vue&type=template&id=f95553d2&"
import script from "./section-image.vue?vue&type=script&lang=js&"
export * from "./section-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports